import { MapType } from "..";
import { formatDateForMap } from "../../utils";
import { Position, Geofence } from "../Store/types";
import {CustomDrawingManager} from "@Safemate/map/Map/drawingManager";
// import {MapLabel} from "./mapLabel";

type FenceOverlay = google.maps.Circle | google.maps.Polygon;

export class MapWrapper{
  private map: any;
  private maps: any;
  private positions: Position[] = [];
  private markers: Map<number, google.maps.marker.AdvancedMarkerElement> = new Map<number, google.maps.AdvancedMarkerElement>();
  private circles: Map<number, google.maps.Circle> = new Map<number, google.maps.Circle>();
  private polylines: google.maps.Polyline[] = [];
  private mapInitialized: boolean = false;
  private drawingManager: any;
  private mapType: MapType;
  private overlays: FenceOverlay[] = [];


  constructor(){}

  public init = (map:any, maps: any, mapType: MapType) => {
    this.map = map;
    this.maps = maps;
    this.mapType = mapType;
    this.drawingManager = new CustomDrawingManager(map, maps);
    this.setDrawingManager(this.drawingManager);
    this.setMapInitialized(true);
  }

  public createMarkers = () =>{
    const self = this;
    if( self.mapInitialized ){
      self.clearMarkers();
      self.positions.map(( position: Position, index:number ) => {
        self.createMarker(position, index);
      });
      if(this.mapType === MapType.SINGLE){
        self.drawPaths();
      }
      self.fitBounds();
    }
  }

  public isMapInitialized(){
    return this.mapInitialized;
  }

  public setMapInitialized(val: boolean){
    return this.mapInitialized = val;
  }

  public setPositions = ( positions: Position[] ) => {
    const currentPositionIds = this.positions.map(pos => pos.tranId);
    let hasNew = currentPositionIds.length !== positions.length;
    if(!hasNew)
      positions.forEach(pos => {
        if(!currentPositionIds.includes(pos.tranId)){
          hasNew = true;
        }
      })
    if(hasNew){
      this.positions = positions;
      if(this.mapInitialized){
        this.createMarkers();
      }
    }
  }

  private createAccuracyCircle = (position: Position, index:number) => {
    const self = this;
    if( position.accuracy !== 0 && index===0 ){
      const circle = new google.maps.Circle({
        strokeColor: "#808080",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#c7c7c7",
        fillOpacity: 0.35,
        map: self.map,
        center: {lat: parseFloat(position.posLati), lng: parseFloat(position.posLong)},
        radius: position.accuracy,
      });
      self.circles.set(index, circle);
    } else if( position.accuracy && position.accuracy !== 0 ) {
      const circle = new google.maps.Circle({
        strokeColor: "#808080",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#c7c7c7",
        fillOpacity: 0.35,
        map: self.map,
        center: {lat: parseFloat(position.posLati), lng: parseFloat(position.posLong)},
        radius: position.accuracy,
      });
      circle.setMap(null);
      self.circles.set(index, circle);
    }
  }

  private createMarkerContent = (position: Position)=> {
    // Build the icon image element
    const iconEl = document.createElement('img');
    iconEl.src = getMarker(position);

    // Replicate the anchor: Point(7.5, 7.5) — centers the icon on the point
    if (!position.drawMarker) {
      iconEl.style.marginBottom = '-7.5px';
    }

    // Build the label element (replaces the `label` option)
    const labelEl = document.createElement('div');
    labelEl.className = position.drawMarker ? 'mapMarkerLabelDraw' : 'mapMarkerLabel';
    labelEl.textContent = position.drawMarker
      ? `${position.deviceName} (${formatDateForMap(position.posTime)})`
      : formatDateForMap(position.posTime);



    if( position.drawMarker ){
      const marker = document.createElement('div');
      marker.className = 'mapMarkerLabelDraw';
      marker.textContent = labelEl.textContent;
      marker.style.position = 'fixed';
      marker.style.visibility = 'hidden';
      marker.style.top = '-9999px';
      document.body.appendChild(marker);
      const width = marker.getBoundingClientRect().width;
      document.body.removeChild(marker);
      const marginLeftPx = width + 50;
      labelEl.style.marginLeft = `${marginLeftPx}px`;

    }

    // Wrap both into a container as the marker content
    const container = document.createElement('div');
    container.className = 'mapMarkerContainer';
    container.appendChild(labelEl);
    container.appendChild(iconEl);
    return container;
  }

  private createMarker = (position: Position, index: number) =>{
    const self = this;
    const { AdvancedMarkerElement } = self.maps.marker;

    const marker = new AdvancedMarkerElement({
      position: {lat: parseFloat(position.posLati), lng: parseFloat(position.posLong)},
      map : self.map,
      content: self.createMarkerContent(position),
      zIndex : (1234 - index)
    });

    if(position.drawMarker && (position.sat || position.hdop)){
      var contentString = "<div class=\"infoWindow\">";
      if (position.sat) {
        contentString = contentString.concat("<span>SAT: "+position.sat+"</span><br/>");
      }
      if (position.hdop) {
        contentString = contentString.concat("<span>HDOP: "+position.hdop+"</span><br/>");
      }
      contentString = contentString.concat("</div>");
      
      var infowindow = new self.maps.InfoWindow({
        content : contentString,
        pixelOffset : new self.maps.Size(0, 0)
      });
      
      marker.addListener('gmp-click', function(){
        if(self.mapType === MapType.SINGLE){
          infowindow.open(self.map, marker);
        }
        else if(self.mapType === MapType.ALL){
          location.hash = `mapsingle/${position.deviId}`;
        }
      });
    }
    self.markers.set(index, marker);
    self.createAccuracyCircle(position, index);
  }

  private clearMarkers = () => {
    const self= this;
    for(let entry of self.markers.entries()){
      entry[1].setMap(null);
    }
    for(let entry of self.circles.entries()){
      entry[1].setMap(null);
    }
    for(let i = 0; i < self.polylines.length; i++){
      self.polylines[i].setMap(null);
    }
    self.polylines = [];
    self.markers.clear();
    self.circles.clear();
  }

  private drawPaths = () => {
    const self = this;
    const count = self.positions.length;
    if(count > 1) {
      self.polylines = new Array();
      const minOpacity = 0.5;
      const maxOpacity = 1.0;
      const segmentCount = count - 1;
      for (let i = 0; i < segmentCount; i++) {
        const start = self.positions[i];
        const end = self.positions[i + 1];
        const path = [
          new google.maps.LatLng(parseFloat(start.posLati), parseFloat(start.posLong)),
          new google.maps.LatLng(parseFloat(end.posLati), parseFloat(end.posLong))
        ];
        const color = isGps(start) && isGps(end) ? '#000' : '#ffa500';
        // positions[0] is the freshest plot, so earlier segments are the newest
        const freshnessRatio = 1 - i / Math.max(segmentCount - 1, 1);
        const opacity = minOpacity + freshnessRatio * (maxOpacity - minOpacity);
        self.addPolyline(path, color, opacity);
      }
    }		
  }

  private addPolyline = (path: any, strokeColor: string, strokeOpacity: number = 1.0) => {
    const self = this;
    var polyline = new google.maps.Polyline({
      path,
      strokeColor,
      strokeWeight : 2,
      strokeOpacity,
      clickable : true
    });
    polyline.setMap(this.map);
    polyline.addListener("mouseover", self.showCircles);
    polyline.addListener("mouseout", self.hideCircles);
    this.polylines.push(polyline);
  }

  private showCircles = () => {
    const self = this;
    for(let entry of self.circles.entries()){
      entry[1].setMap(self.map);
    }
  }

  private hideCircles = () => {
    const self = this;
    for(let entry of self.circles.entries()){
      entry[1].setMap(null);
    }
  }
  
  private fitBounds = () => {
    const self = this;
    if( self.positions.length > 0 && self.markers.size > 0){
      let bounds = new google.maps.LatLngBounds();
      self.markers.forEach((marker) => {
        if(bounds && !bounds.contains(marker.position)){
          bounds.extend(marker.position);
        }
      })
      if( self.circles && self.circles.size > 0 ){
        self.circles.forEach(( value ) => {
          bounds = bounds.union(value.getBounds());
        })
      }
      if(bounds && !bounds.isEmpty()) {
        self.map.setOptions({maxZoom: 16});
        self.map.fitBounds(bounds);
        self.map.setOptions({maxZoom: 20});
      }
    }
  } 

  public createFences = (geofence: Geofence[]) => {
    const self = this;
    if(!self.map || !self.maps || !self.drawingManager) return;
  
    this.overlays.forEach(o => o.setMap(null));
    this.overlays = [];

    geofence.forEach((fence: Geofence) => {
      if (fence.enabled) {
        if (fence.polygon) {
          self.createPolygon(fence);
        } else {
          self.createCircle(fence);
        }
      }
    });
  }

  public createPolygon = (fence: Geofence) => {

    const path = fence.vertices.map((edge) => {
      return {
        lat: edge.lat,
        lng: edge.lng
      }
    })
  
    var poly = new google.maps.Polygon({
      paths : path,
      fillOpacity : 0.3,
      fillColor : fence.enabled ?'green':'gray',
      strokeColor : fence.enabled ?'green':'gray',
      strokeWeight : 2,
      clickable : false,
      editable : false,
      map: this.map,
    });
  
    fence.shape = poly;
    this.overlays.push(poly);
  }

  public createCircle = (fence: Geofence) => {
    const circle = new google.maps.Circle({
      center : {
        lat : parseFloat(getCenterLat(fence)),
        lng : parseFloat(getCenterLng(fence))
      },
      radius : fence.radius,
      fillOpacity : 0.3,
      fillColor : fence.enabled ? 'green' : 'gray',
      strokeColor : fence.enabled ? 'green' : 'gray',
      strokeWeight : 2,
      clickable : false,
      editable : false,
      map: this.map,
    });
  
    fence.shape = circle;
    this.overlays.push(circle);
  }

  public setDrawingManager = (drawingManager: any) => {
    this.drawingManager = drawingManager
  }

}


export const getMarker = (position: Position) => {
  if(!position.drawMarker){
    if(position.metyId === 1){
      return '/common/images/map/pointer_alarm.png';
    }
    else{
      return '/common/images/map/pointer.png';
    }
  }
  if (position.alarmWarning) {
    return '/proffweb/images/map/alarm-map-icon.png';
  }
  if (position.manDownWarning) {
    return '/proffweb/images/map/fall-map-icon.png';
  }
  if (position.geofenceWarning) {
    return '/proffweb/images/map/geofence-map-icon.png';
  }
  if (position.outOfBatteryWarning) {
    return '/proffweb/images/map/out-of-battery-map-icon.png';
  }
  if (position.selfCheckWarning) {
    return '/proffweb/images/map/selfcheck-map-icon.png';
  }
  if (position.inactiveWarning) {
    return '/proffweb/images/map/inactive-map-icon.png';
  }
  if (position.batteryWarning) {
    return '/proffweb/images/map/low-bat-map-icon.png';
  }
  if (position.offlineWarning) {
    return '/proffweb/images/map/offline-map-icon.png';
  }
  return '/proffweb/images/map/clear-map-icon.png';
}

export const setImageForMarker = (url:string, marker: any) => {
  const iconImage = document.createElement("img");
  iconImage.src = url;
  marker.content = iconImage;
}

const isGps = (position: Position) => {
  return position.posType === 0 || position.posType === 6;
};

export const isValid = (position: Position) => {
  if(position.posLati && position.posLong && position.posTime){
    return true;
  }
  return false;
}

const getCenterLat = (fence: Geofence) => {
  if (fence.vertices.length > 0){
    return `${fence.vertices[0].lat}`;
  }
  return "0";
};
const getCenterLng = (fence: Geofence) => {
  if (fence.vertices.length > 0){
    return `${fence.vertices[0].lng}`;
  }
  return "0";
};
